<template>
    <slot>
        <div class="row">
            <div class="col-lg-8">
                <h2>Payment</h2>
                <table class="table create-billing border table-totals">
                    <tbody>
                        <tr>
                            <td class="product px-2">
                                <v-select
                                    placeholder="Select Cash & Bank Account"
                                    class="w-100"
                                    v-model="formData.mop_account_head_id"
                                    name="mop_account_head_id"
                                    :options="cashAndBank"
                                    label="name"
                                    :reduce="name => name.id"
                                />
                            </td>
                            <td class="comma-sep">:</td>
                            <td class="price text-right px-2"> 
                                <vField
                                    v-model="formData.payment"
                                    name="amount"
                                    type="number"
                                    class="form-control text-right"
                                    @keyup="validatePaymentAmount"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-lg-4">
                <h2>Change</h2>
                <div class="mb-1">
                    <label class="form-label">Collection Amount</label>
                    <div class="col-12 col-md-12">
                        <vField
                            v-model="receivedAmount"
                            name="receivedAmount"
                            type="number"
                            class="form-control text-right"
                    
                        />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Change Amount</label>
                    <div class="col-12 col-md-12">
                        <input
                            :value="changeAmount"
                            name="receivedAmount"
                            type="number"
                            class="form-control text-right"
                            readonly
                        />
                    </div>
                </div>
            </div>
        </div>
    </slot>
</template>

<script setup>
import { computed, inject, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

const $router = useRoute();
const formData = inject('formData')
const showError = inject('showError')
const props = defineProps({
    grandTotal: {
        type: Number
    },
    isHospitalInvoice: {
        type: Boolean,
        default: false
    },
    cashAndBank: {
        type: Array,
        default: () => []
    }
})

const companyId = $router.params.companyId;
const receivedAmount = ref(null)

const setInitialValue = (array, field) => {
    if(!array.length) return;
    if (!formData.value[field]) {
        formData.value[field] = array[0].id;
    }
}

watch(() => props.grandTotal, (newVal) => {
  formData.value.payment = 0;

  const currentPayment = parseFloat(formData.value.payment || 0);
  const newGrandTotal = parseFloat(newVal || 0);

  if (currentPayment <= 0 || currentPayment === parseFloat(props.grandTotal)) {
    formData.value.payment = newGrandTotal;
  }
});

const totalAmount = computed(() => props.grandTotal)

const validatePaymentAmount = (event) => {
    const amount = event.target.value
    if (amount < 0) {
        showError("Payment Amount cannot be less than 0")
    }

    if (amount > totalAmount.value) {
        formData.value.payment = totalAmount.value
    }
}

const changeAmount = computed(() => {
    if (formData.value.payment > 0 && receivedAmount.value && receivedAmount.value > 0) {
        return receivedAmount.value - formData.value.payment;
    }
    return 0
})

const generateMoneyReceiptNumber = () => {
    receivedAmount.value = null;
}

const resetMoneyReceipt = () => {
    formData.value.payment = null;
    receivedAmount.value = null;
}

onMounted(() => {
    Promise.all([
        generateMoneyReceiptNumber(),
    ])
    .catch(e => {})
})

defineExpose({generateMoneyReceiptNumber, resetMoneyReceipt})
</script>

<style setup>
.font-20 {
    font-size: 20px;
}
</style>
